class ProductCard extends HTMLElement {
  #observer = null;

  connectedCallback() {
    if (this.closest('swiper-slide')) {
      const innerSwiper = this.querySelector('swiper-container');
      if (innerSwiper) innerSwiper.setAttribute('allow-touch-move', 'false');
    }

    this.addEventListener('mouseover', (e) => {
      const swatch = e.target.closest('[data-swatch][href]');
      if (swatch) { this.#warmProduct(swatch.href); return; }
      const pdpLink = e.target.closest('a[href*="/products/"]');
      if (pdpLink) window._warmSwatch?.(pdpLink.href);
    }, { passive: true });

    this.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-swatch]');
      if (swatch) {
        e.preventDefault();
        this.#loadProduct(swatch.href);
        return;
      }
      const mediaArea = e.target.closest('[data-product-url]');
      if (mediaArea && !e.target.closest('button, a')) {
        window.location.href = mediaArea.dataset.productUrl;
      }
    });

    this.#syncReviewCount();
    this.#watchBadge();
  }

  #watchBadge() {
    this.#observer?.disconnect();
    const widget = this.querySelector('.jdgm-widget');
    if (!widget) return;
    this.#observer = new MutationObserver(() => this.#syncReviewCount());
    this.#observer.observe(widget, { childList: true, subtree: true, characterData: true });
  }

  #syncReviewCount() {
    const span = this.querySelector('[data-reviews-count]');
    if (!span) return;
    const text = this.querySelector('.jdgm-prev-badge__text')?.textContent ?? '';
    const match = text.match(/\d[\d,]*/);
    span.textContent = match ? `(${match[0]})` : '';
  }

  #warmProduct(url) {
    const parsed = new URL(url, window.location.origin);
    const handle = parsed.pathname.split('/products/')[1];
    const fetchUrl = `${parsed.origin}/products/${handle}?section_id=product-card`;
    if (!this._cardCache) this._cardCache = new Map();
    if (this._cardCache.has(fetchUrl)) return;
    this._cardCache.set(fetchUrl, fetch(fetchUrl).then(r => r.text()));
  }

  async #loadProduct(url) {
    const parsed = new URL(url, window.location.origin);
    const handle = parsed.pathname.split('/products/')[1];
    const params = new URLSearchParams();
    params.set('section_id', 'product-card');
    const fetchUrl = `${parsed.origin}/products/${handle}?${params}`;

    try {
      const text = await (this._cardCache?.get(fetchUrl) ?? fetch(fetchUrl).then(r => r.text()));
      this._cardCache?.delete(fetchUrl);

      const doc = new DOMParser().parseFromString(text, 'text/html');
      const next = doc.querySelector('#shopify-section-product-card product-card');
      if (!next) return;

      const swap = () => {
        for (const attr of [...this.attributes]) this.removeAttribute(attr.name);
        for (const attr of [...next.attributes]) this.setAttribute(attr.name, attr.value);
        this.style.viewTransitionName = 'product-card-active';
        this.innerHTML = next.innerHTML;
        this.#syncReviewCount();
        this.#watchBadge();
      };

      if (document.startViewTransition) {
        this.style.viewTransitionName = 'product-card-active';
        const t = document.startViewTransition(swap);
        t.finished.then(() => { this.style.viewTransitionName = ''; });
      } else {
        swap();
      }
    } catch {
      window.location.href = url;
    }
  }
}

customElements.define('product-card', ProductCard);
